import React from "react";
import styled from "styled-components";
import fontSize from "../../../theme/fonts/FontTheme";
import colors from "../../../theme/color/ColorTheme";

const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
  margin: 80px auto;
  box-sizing: border-box;
`;

const Heading = styled.h2`
  text-align: center;
  padding: 24px;
  font-weight: 400;
  font-size: ${fontSize.m};
  letter-spacing: 0.12rem;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: clamp(3.5rem, (64 / 1920) * 100vw, 4rem);
  align-items: center;

  @media (max-width: 840px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;

const ContactItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  gap: clamp(0.25rem, (8 / 1920) * 100vw, 0.5rem);
  div {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  h3 {
    letter-spacing: 0.1em;
    font-weight: 300;
    font-size: ${fontSize.m};
  }
  span {
    font-size: ${fontSize.s};
  }
  a {
    position: relative;
    cursor: pointer;
    color: ${colors.black};
    font-size: ${fontSize.s};
    text-decoration: none;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -4px;
      width: 100%;
      height: 1px;
      background-color: white;
      transform: translateX(-50%) scaleX(0);
      transform-origin: center;
      transition: transform 0.3s ease, background-color 0.3s ease;
    }

    &:hover::after {
      transform: translateX(-50%) scaleX(1);
      background-color: black;
    }
  }

  a:link,
  a:visited,
  a:active {
    color: inherit;
    text-decoration: none;
  }
`;

const contacts = [
  {
    label: "SUPPORT",
    type: "Email",
    value: "support@peakpashmina.com",
    link: "mailto:support@peakpashmina.com",
  },
  {
    label: "CALL",
    type: "Phone",
    value: "+977-9813820652",
    link: "tel:+9779813820652",
  },
  {
    label: "CHAT",
    type: "Whatsapp",
    value: "+977-9813820652",
    link: "https://wa.link/k8x2ia",
  },
];

function NeedAssistanceSection() {
  return (
    <Wrapper>
      <Heading>NEED ASSISTANCE?</Heading>
      <ContactGrid>
        {contacts.map((contact, index) => (
          <ContactItem key={index}>
            <h3 className="label">{contact.label}</h3>
            <div>
              <span>{contact.type}:</span>
              <a href={contact.link}>{contact.value}</a>
            </div>
          </ContactItem>
        ))}
      </ContactGrid>
    </Wrapper>
  );
}

export default NeedAssistanceSection;
